import "./index.css";
import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { getaddress } from "../../functions";

export default function AddressInput({ onGetAddress, oldAddress, hex, white }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);
  const [postcode, setPostcode] = useState("");
  const [address, setAddress] = useState({});
  const [findingAddress, setFindingAddress] = useState(false);

  const Styles = useMemo(
    () => ({
      control: (styles) => ({
        ...styles,
        backgroundColor: "white",
        width: "100%",
      }),
    }),
    [selectedOption]
  );

  useEffect(() => {
    if (JSON.stringify(address) !== JSON.stringify(oldAddress)) {
      const { address1, city, state, zipcode } = address;
      if (address1 && city && state && zipcode) {
        onGetAddress(address);
      }
    }
  }, [address]);

  useEffect(() => {
    if (oldAddress) {
      setAddress(oldAddress);
    }
  }, [oldAddress]);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    onGetAddress(selectedOption);
  };
  const handleChangePostcode = ({ target }) => {
    setPostcode(target.value);
  };
  const findAddress = () => {
    setFindingAddress(true);
    getaddress(postcode)
      .then((res) => {
        if (res.status === "OK") {
          setOptions(
            res.results.map((item) => {
              return { value: item, label: item.formatted_address };
            })
          );
        } else {
          setOptions([{ value: "No Address", label: "No Address" }]);
        }
        setFindingAddress(false);
      })
      .catch((e) => {
        console.error("erroing finding address", e);
        setFindingAddress(false);
        setOptions([{ value: "No Address", label: "No Address" }]);
      });
  };

  return (
    <div className="address-input-container">
      <div className="postcode-container">
        <input
          type="text"
          className="form-control"
          name="postcode"
          placeholder="Address"
          onChange={handleChangePostcode}
        />
        <button
          className={`btn btn-white btn-brand-hex ml-2`}
          style={{
            "--hover-color": hex ? hex : "white",
            "--hover-text-color": white ? "white" : "black",
            backgroundColor: hex ? hex : "white",
            color: white ? "white" : "black",
          }}
          onClick={findAddress}
        >
          Find Address
        </button>
      </div>
      {findingAddress && <i className="fa fa-2x fa-sync fa-spin text-muted" />}
      {options.length > 0 && (
        <div className="mt-2 select-container">
          <Select
            placeholder="Select full address..."
            value={selectedOption}
            onChange={handleChange}
            options={options}
            styles={Styles}
            menuPlacement="bottom"
          />
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/AddressInput/index.js